// import api from "./api";

// export const reportService = {
//   // Get all bets report
//   getBetReport: async () => {
//     const response = await api.get("/reports/bets");
//     return response.data;
//   },

//   // Get transaction logs report
//   getTransactionReport: async () => {
//     const response = await api.get("/reports/transactions");
//     return response.data;
//   },

//   getShopLossCredits: async () => {
//   const response = await api.get("/reports/shop-loss-credits");
//   return response.data;
// },

//   // Get game rounds report
//   getRoundReport: async () => {
//     const response = await api.get("/reports/rounds");
//     return response.data;
//   },

//   // Get wallet history
//   getWalletHistory: async () => {
//     const response = await api.get("/reports/wallet-history");
//     return response.data;
//   },

//   // Get shop settlement summary (for SHOP role)
//   getShopSettlement: async () => {
//     const response = await api.get("/reports/shop-settlement");
//     return response.data;
//   }
// };

// export default reportService;





// import api from "./api";

// export const reportService = {

//   // ================= PLAYER / OLD REPORTS =================

//   // Get all bets report
//   getBetReport: async () => {
//     const response = await api.get("/reports/bets");
//     return response.data;
//   },

//   // Get transaction logs report
//   getTransactionReport: async () => {
//     const response = await api.get("/reports/transactions");
//     return response.data;
//   },

//   // Get shop loss credits
//   getShopLossCredits: async () => {
//     const response = await api.get("/reports/shop-loss-credits");
//     return response.data;
//   },

//   // Get game rounds report
//   getRoundReport: async () => {
//     const response = await api.get("/reports/rounds");
//     return response.data;
//   },

//   // Get wallet history
//   getWalletHistory: async () => {
//     const response = await api.get("/reports/wallet-history");
//     return response.data;
//   },

//   // Get shop settlement summary
//   getShopSettlement: async () => {
//     const response = await api.get("/reports/shop-settlement");
//     return response.data;
//   },


//   // ================= COMPUTER REPORTS =================

//   // Computer session history
//   getComputerSessions: async () => {
//     const response = await api.get("/reports/computer-sessions");
//     return response.data;
//   },

//   // Computer demo-credit transaction history
//   getComputerTransactions: async () => {
//     const response = await api.get("/reports/computer-transactions");
//     return response.data;
//   },

//   // Computer game/activity history
//   getComputerActivity: async () => {
//     const response = await api.get("/reports/computer-activity");
//     return response.data;
//   },

// };

// export default reportService;






import api from "./api";

export const reportService = {
  // ================= OLD / EXISTING REPORTS =================

  // Existing bet report
  getBetReport: async () => {
    const response = await api.get("/reports/bets");
    return response.data;
  },

  // Credit transfer report
  getTransactionReport: async () => {
    const response = await api.get("/reports/transactions");
    return response.data;
  },

  // Existing shop loss credits
  getShopLossCredits: async () => {
    const response = await api.get("/reports/shop-loss-credits");
    return response.data;
  },

  // Game rounds report
  getRoundReport: async () => {
    const response = await api.get("/reports/rounds");
    return response.data;
  },

  // Wallet history
  getWalletHistory: async () => {
    const response = await api.get("/reports/wallet-history");
    return response.data;
  },

  // Existing shop settlement summary
  getShopSettlement: async () => {
    const response = await api.get("/reports/shop-settlement");
    return response.data;
  },

  // Shop Computer performance / Win-Loss report
  getShopComputerReport: async () => {
    const response = await api.get("/reports/shop-computer-performance");
    return response.data;
  },
};

export default reportService;